// Top-level wrapper — auth gate + router. Application state (userRole) lives
// in `state/application/useUiStore`; the merged AppData shape consumers used
// to read from a context is now produced by the `useAppData` composition hook
// (hooks/useAppData.ts).
import React from 'react';
import { RouterProvider } from 'react-router';
import { router } from './router';
import { useAuth } from './hooks/useAuth';
import AuthBootScreen from './components/AuthBootScreen';

export default function App() {
  const auth = useAuth();

  if (!auth.initDone) {
    return <AuthBootScreen />;
  }

  if (auth.error && !auth.currentUser) {
    const isLocalhost = window.location.hostname === 'localhost';
    return (
      <div style={{ maxWidth: 560, margin: '64px auto', padding: 24 }}>
        <h2 className="header3">Authentication unavailable</h2>
        <p className="body2" style={{ marginTop: 12 }}>{auth.error.message}</p>
        {isLocalhost ? (
          <>
            <p className="body2" style={{ marginTop: 16 }}>
              You&apos;re running on raw
              {' '}
              <code>localhost</code>
              . The Withings
              auth cookie lives on
              {' '}
              <code>.corp.withings.com</code>
              {' '}
              and
              can&apos;t reach localhost. Two options:
            </p>
            <ol className="body2" style={{ marginTop: 8, paddingLeft: 20 }}>
              <li>
                Set up the dev vhost (recommended). See
                {' '}
                <code>CLAUDE.md</code>
                {' '}
                → &quot;Local dev via vhost&quot;.
              </li>
              <li>
                Paste a session key manually via the profile menu in the
                sidebar (legacy fallback — kept for now).
              </li>
            </ol>
          </>
        ) : (
          <p className="body2" style={{ marginTop: 16 }}>
            Try reloading. If the problem persists, contact the platform team.
          </p>
        )}
      </div>
    );
  }

  return <RouterProvider router={router} />;
}
